import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { secondAnalysesActions } from 'features/secondAnalyses';

const useSecondAnalyses = () => {
  const dispatch = useDispatch();
  const getSecondAnalyses = useCallback(({ offset }) => dispatch(secondAnalysesActions.getSecondAnalyses({ offset })), [dispatch]);
  const getSecondAnalysis = useCallback(({ id, cable }) => dispatch(secondAnalysesActions.getSecondAnalysis({ id, cable })), [dispatch]);
  const createSecondAnalysis = useCallback((second_analysis) => dispatch(secondAnalysesActions.createSecondAnalysis(second_analysis)), [dispatch]);
  const clearLocalSecondAnalyses = useCallback(() => dispatch(secondAnalysesActions.clearLocalSecondAnalyses()), [dispatch]);
  const clearLocalActiveSecondAnalysis = useCallback(() => dispatch(secondAnalysesActions.clearLocalActiveSecondAnalysis()), [dispatch]);

  return {
    getSecondAnalyses,
    getSecondAnalysis,
    createSecondAnalysis,
    clearLocalSecondAnalyses,
    clearLocalActiveSecondAnalysis
  };
};

export default useSecondAnalyses;